export const SET_USER = 'SET_USER';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_PERFORMANCES = 'SET_PERFORMANCES';
export const SET_PERFORMANCE = 'SET_PERFORMANCE';
export const SET_CURRENT_RECORDING = 'SET_CURRENT_RECORDING';
export const SET_DATE_ADJUSTMENT = 'SET_DATE_ADJUSTMENT';
export const SET_PAGE = 'SET_PAGE';
export const SET_DOWNLOAD_VIDEO = 'SET_DOWNLOAD_VIDEO';
export const SET_PERFORMANCES_LOADING = 'SET_PERFORMANCES_LOADING';